import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formElement = e.target as HTMLFormElement;
      const formDataToSend = new FormData(formElement);
      
      const response = await fetch('https://readdy.ai/api/form/d5kc6ks8iuo4ujd55r90', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formDataToSend as any).toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', message: '' });
        
        setTimeout(() => {
          setSubmitStatus('idle');
        }, 5000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 px-6">
      <div className="max-w-[800px] mx-auto">
        <div className="bg-gradient-to-br from-white to-[#F0FFF5]/50 rounded-[32px] p-12 lg:p-16 shadow-[0_8px_24px_rgba(0,0,0,0.06)]">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-[#FF6B6B] to-[#6B5FFF] bg-clip-text text-transparent mb-4">
              Ready to Build the Future of Pets?
            </h2>
            <p className="text-lg text-[#4A5568] flex items-center justify-center gap-2">
              We'd love to hear from you. Drop us a message below. <span className="text-2xl">🐾</span>
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="contact_application">
            {/* Name Input */}
            <div>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                className="w-full h-16 px-6 text-lg bg-white border-2 border-[#E2E8F0] rounded-xl focus:border-transparent focus:ring-4 focus:ring-[#FF6B6B]/30 focus:outline-none transition-all duration-300"
              />
            </div>

            {/* Email Input */}
            <div className="relative">
              <input
                type="email"
                name="email"
                placeholder="your@email.com"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="w-full h-16 px-6 pr-14 text-lg bg-white border-2 border-[#E2E8F0] rounded-xl focus:border-transparent focus:ring-4 focus:ring-[#FF6B6B]/30 focus:outline-none transition-all duration-300"
              />
              <i className="ri-mail-line absolute right-5 top-1/2 -translate-y-1/2 text-xl text-[#4A5568]"></i>
            </div>

            {/* Message Textarea */}
            <div>
              <textarea
                name="message"
                placeholder="Tell us about your pet startup idea..."
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                required
                maxLength={500}
                rows={6}
                className="w-full px-6 py-4 text-lg bg-white border-2 border-[#E2E8F0] rounded-xl focus:border-transparent focus:ring-4 focus:ring-[#FF6B6B]/30 focus:outline-none transition-all duration-300 resize-vertical"
              />
              <p className="text-sm text-[#4A5568] mt-2 text-right">
                {formData.message.length}/500 characters
              </p>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full h-18 bg-gradient-to-r from-[#FF6B6B] to-[#6B5FFF] text-white text-xl font-bold rounded-2xl shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? (
                <>
                  <i className="ri-loader-4-line text-2xl animate-spin"></i>
                  Sending...
                </>
              ) : (
                <>
                  Submit Application
                  <i className="ri-send-plane-fill text-2xl"></i>
                </>
              )}
            </button>

            {/* Status Messages */}
            {submitStatus === 'success' && (
              <div className="p-4 bg-green-50 border-2 border-green-200 rounded-xl text-center">
                <p className="text-green-700 font-medium flex items-center justify-center gap-2">
                  <i className="ri-checkbox-circle-fill text-xl"></i>
                  Thank you! We'll be in touch soon.
                </p>
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="p-4 bg-red-50 border-2 border-red-200 rounded-xl text-center">
                <p className="text-red-700 font-medium flex items-center justify-center gap-2">
                  <i className="ri-error-warning-fill text-xl"></i>
                  Something went wrong. Please try again.
                </p>
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}